import axiosInstance from '../axiosInstance';

/**
 * One slice of an event's audit log. `from` and `to` are ISO timestamps; the
 * server clamps the portal access view to its 12-month retention window.
 */
export const list = (eventId, { view = 'changes', from = '', to = '' } = {}) =>
  axiosInstance
    .get(`/event/${encodeURIComponent(eventId)}/audit`, {
      params: {
        view,
        ...(from ? { from } : {}),
        ...(to ? { to } : {})
      }
    })
    .then((response) => response.data);

const auditService = { list };

export default auditService;
